export default __webpack_public_path__ + "581a441619abfd1902381ca80d1808b0.png";